export default [
    {
        path: 'invoices',
        name: 'master-data-invoices',
        meta: {
            modules: ['crm'],
            authentication_required: true,
            authorization_required: null,
            translate: (t) => {
                return t('menu_points.invoices').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        children: [
            {
                path: 'vats',
                name: 'invoices-vats',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: ['roles.vats.view'],
                    translate: (t) => {
                        return t('menu_points.vats').ucFirst();
                    },
                },
                component: () => import('@/views/helpers/grouper/grouper.vue'),
                redirect: { name: 'invoices-vats-list'},
                children: [
                    {
                        path: '',
                        name: 'invoices-vats-list',
                        meta: {
                            modules: ['crm'],
                            authentication_required: true,
                            authorization_required: ['roles.vats.view'],
                            translate: (t) => {
                                return t('menu_points.vats').ucFirst();
                            },
                        },
                        component: () => import('@/views/pages/invoices/vats/list.vue'),
                    },
                    {
                        path: 'create',
                        name: 'invoices-vat-create',
                        meta: {
                            modules: ['crm'],
                            authentication_required: true,
                            authorization_required: ['roles.vats.create'],
                            translate: (t, tc) => t('base.create_new_item', {item: tc('invoices::vats.vat', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/invoices/vats/item.vue')
                    },
                    {
                        path: ':id(\\d+)',
                        name: 'invoices-vat-edit',
                        meta: {
                            modules: ['crm'],
                            authentication_required: true,
                            authorization_required: ['roles.vats.edit'],
                            translate: (t, tc) => t('base.edit_item', {item: tc('invoices::vats.vat', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/invoices/vats/item.vue')
                    },
                ]
            },
            {
                path: 'invoice-types',
                name: 'invoices-invoice-types',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: ['roles.invoice_types.view'],
                    translate: (t) => {
                        return t('menu_points.invoice-types').ucFirst();
                    },
                },
                component: () => import('@/views/helpers/grouper/grouper.vue'),
                redirect: { name: 'invoices-invoice-types-list'},
                children: [
                    {
                        path: '',
                        name: 'invoices-invoice-types-list',
                        meta: {
                            modules: ['crm'],
                            authentication_required: true,
                            authorization_required: ['roles.invoice_types.view'],
                            translate: (t) => {
                                return t('menu_points.invoice_types').ucFirst();
                            },
                        },
                        component: () => import('@/views/pages/invoices/invoice-types/list.vue'),
                    },
                    {
                        path: 'create',
                        name: 'invoices-invoice-type-create',
                        meta: {
                            modules: ['crm'],
                            authentication_required: true,
                            authorization_required: ['roles.invoice_types.create'],
                            translate: (t, tc) => t('base.create_new_item', {item: tc('invoices::types.type', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/invoices/invoice-types/item.vue')
                    },
                    {
                        path: ':id(\\d+)',
                        name: 'invoices-invoice-type-edit',
                        meta: {
                            modules: ['crm'],
                            authentication_required: true,
                            authorization_required: ['roles.invoice_types.edit'],
                            translate: (t, tc) => t('base.edit_item', {item: tc('invoices::types.type', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/invoices/invoice-types/item.vue')
                    },
                ]
            },
        ],
    }
];